import React, { useState, useEffect, useCallback } from "react";
import "../../styles/desktop/listaAgendados.css";
import { getAgendamentos } from "../../API/ListaAgendamentos";

function ListaAgendados({ refreshFlag }) {
  const [listaAgendados, setListaAgendados] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getAgendamentos();
      console.log(data)
      const dataComExecucao = calcularTempoRestante(data);
      setListaAgendados(dataComExecucao);
    };
    fetchData();
  }, [refreshFlag]);

  const recarregar = useCallback(async () => {
    const data = await getAgendamentos();
    const dataComExecucao = calcularTempoRestante(data);
    setListaAgendados(dataComExecucao);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      recarregar();
    }, 60000);

    return () => clearInterval(intervalId); // Limpa o intervalo quando o componente é desmontado
  }, [recarregar]);

  const calcularTempoRestante = (agendamentos) => {
    return agendamentos.map((item) => {
      const agora = new Date();
      const partesHoraFim = item.fim.split(":");
      const partesHoraInicio = item.inicio.split(":");

      const horaFim = new Date(
        agora.getFullYear(),
        agora.getMonth(),
        agora.getDate(),
        parseInt(partesHoraFim[0]),
        parseInt(partesHoraFim[1])
      );

      const horaInicio = new Date(
        agora.getFullYear(),
        agora.getMonth(),
        agora.getDate(),
        parseInt(partesHoraInicio[0]),
        parseInt(partesHoraInicio[1])
      );

      if (agora >= horaInicio && agora <= horaFim) {
        item.execucao = "Executando...";
      } else {
        let diferencaMs;
        if (agora < horaInicio) {
          diferencaMs = horaInicio - agora;
        } else {
          // Adicionar um dia à data de início se a hora atual for maior que a hora de fim
          horaInicio.setDate(horaInicio.getDate() + 1);
          diferencaMs = horaInicio - agora;
        }

        const diferencaHoras = Math.floor(diferencaMs / 3600000);
        const diferencaMinutos = Math.floor((diferencaMs % 3600000) / 60000);
        item.execucao = `${diferencaHoras}:${diferencaMinutos < 10 ? '0' : ''}${diferencaMinutos+1}`;
      }

      return item;
    });
  };

  const handleDelete = async (grupo, inicio) => {
    const confirmDelete = window.confirm(`Deseja realmente excluir o agendamento ${grupo}?`);
    if (confirmDelete) {
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/excluirAgendamento`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ grupo, inicio }),
        });

        if (response.ok) {
          alert('Agendamento excluído com sucesso!');
          recarregar();
        } else {
          alert('Erro ao excluir o agendamento.');
        }
      } catch (error) {
        console.error('Erro ao excluir o agendamento:', error);
        alert('Erro ao excluir o agendamento.');
      }
    }
  };

  return (
    <div id="agendamentos">
      <div id="loader">
        <div className="spinner"></div>
      </div>
      <div id="content-lista">
        <h1 className="textPrincipal">
          Lista de <br />
          Agendamentos
        </h1>
        <div className="campoDaTabela">
          <table id="tabela">
            <thead>
              <tr>
                <th>nome</th>
                <th>Inicio</th>
                <th>Fim</th>
                <th>Tipo</th>
                <th>Execução</th>
              </tr>
            </thead>
            <tbody id="tabelaAgendamentos">
              {listaAgendados.length === 0 ? (
                <tr>
                  <td colSpan="5" id="msgErro">Nenhum agendamento registrado.</td>
                </tr>
              ) : (
                listaAgendados.map((item, index) => (
                  <tr key={index}>
                    <td className="tdNome" onClick={() => handleDelete(item.grupo, item.inicio)}>
                      {item.grupo}
                    </td>
                    <td>{item.inicio}</td>
                    <td>{item.fim}</td>
                    <td>{item.tipo}</td>
                    <td style={{ backgroundColor: item.execucao === "Executando..." ? "#3dbd12" : "transparent", color: item.execucao === "Executando..." ? "white" : "inherit" }}>
                      {item.execucao}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ListaAgendados;